import { AlertTriangle, X } from "lucide-react";

/**
 * ConfirmDeleteModal — réutilisable partout
 * Props :
 *   isOpen   : bool
 *   onClose  : () => void
 *   onConfirm: () => void
 *   itemName : string  — ex: "SN-235151" ou "Sagrada"
 *   itemType : string  — ex: "nœud", "revendeur", "client"
 */
export default function ConfirmDeleteModal({ isOpen, onClose, onConfirm, itemName, itemType = "élément" }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-xl p-6 w-full max-w-md mx-4 z-10">
        {/* Bouton fermer */}
        <button onClick={onClose} className="absolute top-4 right-4 p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-gray-100">
          <X size={18} />
        </button>

        {/* Icône + Titre */}
        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <AlertTriangle size={28} className="text-red-500" />
          </div>
          <h2 className="text-xl font-bold text-slate-800 mb-2">Êtes-vous sûr ?</h2>
          <p className="text-sm text-slate-500 leading-relaxed">
            Cette action est irréversible.{" "}
            {itemName && (
              <>
                Le {itemType} <span className="font-semibold text-slate-700">{itemName}</span>{" "}
              </>
            )}
            sera définitivement supprimé.
          </p>
        </div>

        {/* Boutons */}
        <div className="flex items-center gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 border border-gray-200 rounded-xl text-sm font-semibold text-slate-600 hover:bg-gray-50 transition-colors"
          >
            Annuler
          </button>
          <button
            onClick={() => { onConfirm(); onClose(); }}
            className="flex-1 py-3 bg-red-600 text-white rounded-xl text-sm font-semibold hover:bg-red-700 transition-colors"
          >
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}